/* NetworkDiscoveryResultsViewRenderer.js */

"use strict";
const _ = require("lodash");
// const StatusFlow = require("./StatusFlowComponent");
require("moment-duration-format");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const Registrations = require("../../../../../RegistrationNamespaces");
const StatusFlow = require("../network_discovery_details/StatusFlowComponent");

// this._availableTargetsGrid.renderer._emptyMessage.innerHTML = "No devices available";
const UNKNOWN_DEVICES_EMPTY = "No unknown discovered devices to display";
const ALL_DEVICES_EMPTY = "No discovered devices to display";

const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;

class NetworkDiscoveryResultsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("network-discovery-results-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._renderingForm = false;

        this._updateGridCount = _.debounce(this._updateGridCount.bind(this), 300);

        this._showKnownDevices = false;
        this._filterQuery = {};
        this._filterApplied = false;

        this._noDiscovery = false;

        this._feedRefreshed = true;
        this.hideShowGridMessage = _.debounce(this.hideShowGridMessage.bind(this), 500);
        this.emptyMessage = document.createElement("div");
        this.emptyMessage.classList.add("empty-div");
        const spanText = document.createElement("span");
        spanText.innerText = "No results available";
        this.emptyMessage.appendChild(spanText);

        this._knownDevicesActionCmpnt = undefined;

        this._userDataStorage = this._model._storageFactory.getRemoteStorageInstance(
            "views",
            "network_discovery_result"
        );
        this._onlyCurrentPlan = this._userDataStorage.getData("is_current_plan", true);
        if (_.isUndefined(this._onlyCurrentPlan) || this._onlyCurrentPlan === "") {
            this._onlyCurrentPlan = true;
        }
        if (this._userDataStorage.getData("show_known_devices", true)) {
            this._showKnownDevices = this._userDataStorage.getData("show_known_devices", true);
            this._filterQuery = {
                $and: [
                    {
                        deviceStatus: {$nin: ["KNOWN"]},
                    },
                    {deviceStatus: {$ne: "EXCLUDE"}},
                ],
            };
            this._filterApplied = true;
        } else {
            if (this._onlyCurrentPlan) {
                this._filterQuery = {
                    $and: [{deviceStatus: {$ne: "EXCLUDE"}}],
                };
            } else {
                this._filterQuery = {deviceStatus: {$ne: "EXCLUDE"}};
            }

            this._userDataStorage.setData(this._showKnownDevices, "show_known_devices");
        }

        this._planSelection = new InputRadioControl({
            darkTheme: false,
            horizontal: true,
            options: [
                {
                    label: "Current Plan",
                    tooltip: "Results from current plan will be displayed",
                    value: true,
                },
                {
                    label: "All Plans",
                    tooltip: "Results from all plans will be displayed",
                    value: false,
                },
            ],
            value: this._onlyCurrentPlan,
        });

        this._planSelectionEl = document.createElement("div");
        this._planSelectionEl.classList.add("plan-selection");
        this._planSelectionEl.appendChild(this._planSelection.renderer.rootElement);

        this._rootElem.appendChild(this._planSelectionEl);
        this._discoveredDeviceCount = document.createElement("span");
        this._discoveredDeviceCount.classList.add("discovery-count");

        const rightContainer = document.createElement("div");
        rightContainer.classList.add("right-container");
        rightContainer.appendChild(this._discoveredDeviceCount);

        this.flowGraphic = undefined;
        this._flowGraphicContainer = document.createElement("div");
        this._flowGraphicContainer.className = "status-flow-graphic";
        rightContainer.appendChild(this._flowGraphicContainer);

        this._discoveryStatus = document.createElement("span");
        this._discoveryStatus.classList.add("discovery-status");
        rightContainer.appendChild(this._discoveryStatus);

        this._rootElem.appendChild(rightContainer);

        this._debouncedButtonEnableDisable = _.debounce(
            this.setRunCancelButtonStatus.bind(this),
            300
        );
        this._debouncedSetCount = _.debounce(this._setDeviceCount.bind(this), 500);

        this._gridContainer = document.createElement("network-discovery-results-grid-container");
        this._rootElem.appendChild(this._gridContainer);

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Clear Results",
            name: "clearResults",
            disabled: true,
            handler: (this._onClearResultsClick = this._onClearResultsClick.bind(this)),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Hide Known Devices",
            name: "showKnownDevices",
            handler: (this._onShowKnownDevices = this._onShowKnownDevices.bind(this)),
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Exclude Selection",
            name: "excludeSelection",
            disabled: true,
            handler: (this._onExcludeSelection = this._onExcludeSelection.bind(this)),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Import Selection",
            name: "importSelection",
            disabled: true,
            handler: (this._onImportSelectionClick = this._onImportSelectionClick.bind(this)),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "runCancelButton",
            handler: (this._onRunCancelClick = this._onRunCancelClick.bind(this)),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "download",
            handler: (this._onDownloadClick = this._onDownloadClick.bind(this)),
        });

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._unregisterListeners();
        this._model.on(
            "GridColumnUpdated",
            (this._onGridColumnUpdated = this._onGridColumnUpdated.bind(this))
        );
        // this._model.on("ExecutionFeedUpdated", (this._onExecutionFeedUpdated = this._onExecutionFeedUpdated.bind(this)));
        this._model.on(
            "ResultsFeedUpdated",
            (this._onResultsFeedUpdated = this._onResultsFeedUpdated.bind(this))
        );
        this._model.on(
            "NetworkDiscoveryPropertiesChanged",
            (this._onPlanPropertiesChanged = this._onPlanPropertiesChanged.bind(this))
        );
        this._model.on(
            "ImportComplete",
            (this._onImportComplete = this._onImportComplete.bind(this))
        );
        this._planSelection.on(
            "UserValue",
            (this._onPlanSelectionChange = this._onPlanSelectionChange.bind(this))
        );
        this._model.on(
            "ResetSelectedRows",
            (this._resetSelectedRows = this._resetSelectedRows.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("GridColumnUpdated", this._onGridColumnUpdated);
        this._model.removeAllListeners("ExecutionFeedUpdated");
        this._model.removeAllListeners("ResultsFeedUpdated");
        this._model.removeListener(
            "NetworkDiscoveryPropertiesChanged",
            this._onPlanPropertiesChanged
        );
        this._model.removeListener("ImportComplete", this._onImportComplete);
        this._model.removeListener("ResetSelectedRows", this._resetSelectedRows);
    }

    _registerGridListeners() {
        if (this._deviceEntityGrid) {
            this._unregisterGridListeners();
            this._deviceEntityGrid.on(
                "UserSelectedRows",
                (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
            );
            this._deviceEntityGrid.on(
                "UserSorted",
                (this._onUserSorted = this._onUserSorted.bind(this))
            );
            this._deviceEntityGrid.on(
                "GridBusyStart",
                (this._onGridBusyStart = this._onGridBusyStart.bind(this))
            );
            this._deviceEntityGrid.on(
                "UserRowDoubleClicked",
                (this._onUserDblClickedRow = this._onUserDblClickedRow.bind(this))
            );
        }
    }

    _unregisterGridListeners() {
        if (this._deviceEntityGrid) {
            this._deviceEntityGrid.removeListener("UserSelectedRows", this._onGridUserSelectedRows);
            this._deviceEntityGrid.removeListener("UserSorted", this._onUserSorted);
            this._deviceEntityGrid.removeListener("GridBusyStart", this._onGridBusyStart);
            this._deviceEntityGrid.removeListener(
                "UserRowDoubleClicked",
                this._onUserDblClickedRow
            );
        }
    }

    _registerFeedListeners() {
        this._unregisterFeedListeners();
        this._model.pagingFeed.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
        this._model.pagingFeed.on(
            "FeedInitialized",
            (this._onResultFeedInitialized = this._onResultFeedInitialized.bind(this))
        );
    }
    _unregisterFeedListeners() {
        this._model.pagingFeed.removeListener("RefreshView", this._onFeedRefreshView);
        this._model.pagingFeed.removeListener("FeedInitialized", this._onResultFeedInitialized);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._unregisterGridListeners();
        if (this._model.pagingFeed) {
            this._unregisterFeedListeners();
        }

        let promArr = [this._deviceEntityGrid && this._deviceEntityGrid.shutdown()];
        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._renderingForm = undefined;
                this._gridContainer.remove();
                this._gridContainer = undefined;
                this._discoveredDeviceCount.remove();
                this._discoveredDeviceCount = undefined;
                this._discoveryStatus.remove();
                this._discoveryStatus = undefined;
                this._deviceEntityGrid = undefined;
                this._showKnownDevices = undefined;
                this._filterApplied = undefined;
                this.flowGraphic = undefined;
                this._flowGraphicContainer = undefined;
                this._filterQuery = undefined;
                this._knownDevicesActionCmpnt = undefined;
                this._noDiscovery = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "DeviceDetailsViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.whenModelIsReady(this._filterQuery, this._onlyCurrentPlan).then(
            ({filterQuery}) => {
                this._filterQuery = filterQuery;
                if (!this._knownDevicesActionCmpnt || this._knownDevicesActionCmpnt.length < 1) {
                    this._knownDevicesActionCmpnt =
                        this._model._gameEditor._viewActionsCmpnt.renderer._renderedVaCollection.filter(
                            (action) => action.value === "showKnownDevices"
                        );
                }
                // this.setRunCancelButtonStatus();
                if (!_.isEmpty(this._model._networkDiscoveryResultsFeed)) {
                    this._noDiscovery = false;
                    this.emptyMessage.classList.remove("show");
                    if (_.isEmpty(this._deviceEntityGrid)) {
                        this._deviceEntityGrid = new EntityGrid({
                            gridKey: this.model._gridKey,
                            userGridData: this._model._userGridData,
                            logger: this._logger,
                            singleSelect: false,
                            columns: this._model.columns,
                            pagingFeed: this._model._networkDiscoveryResultsFeed,
                            showHeader: true,
                            showLinesNumber:
                                this._model._gameEditor.renderer._rootElem.querySelector(
                                    "game-editor-view-actions-gl left-container"
                                ),
                            // nonClickableRows: {
                            //     deviceStatus: ["PENDING", "KNOWN", "IMPORTING", "ERROR"]
                            // }
                        });

                        this.createResultLayout();
                        this._updateGridCount();
                    } else {
                        this._deviceEntityGrid.refreshView();
                        this._deviceEntityGrid.refreshLinesNumber();
                        // this._deviceEntityGrid._linesNumberCmpnt.renderer._updateLinesNumber();
                    }
                } else {
                    this._noDiscovery = true;
                    this.emptyMessage.classList.add("show");
                    this._rootElem.appendChild(this.emptyMessage);
                }
                if (!this._onlyCurrentPlan) {
                    this._model._gameEditor.disableViewAction("clearResults");
                }
                this._model.gameEditor.disableViewAction("excludeSelection");
                // this._onPlanSelectionChange(true);
            },
            (err) => err
        );
    }

    async _updateGridCount() {
        // const total = Object.keys(
        //     _.get(this._deviceEntityGrid._pagingFeed, "_feed._cache", {})
        // ).length;
        const total =
            await this._model._networkDiscoveryResultsEntityDef.queryNetworkDiscoveryResultCount(
                this._model.activeOrgId,
                this._filterQuery
            );
        const selected = _.get(this._deviceEntityGrid, "_selectedRows.count", 0);

        this._deviceEntityGrid._linesNumberCmpnt.setLinesNumber({selected, total});

        // this._deviceEntityGrid._linesNumberCmpnt.renderer._updateLinesNumber();
    }

    createResultLayout() {
        if (!this._gridContainer.hasChildNodes()) {
            this._gridContainer.appendChild(this._deviceEntityGrid.renderer.rootElement);
        }

        this._deviceEntityGrid.renderer._emptyMessage.innerHTML = ALL_DEVICES_EMPTY;

        if (this._showKnownDevices) {
            this._model._setViewActionText("showKnownDevices", "Show Known Devices");
            this._deviceEntityGrid.renderer._emptyMessage.innerHTML = UNKNOWN_DEVICES_EMPTY;
            this._showKnownDevices = false;
        } else {
            this._showKnownDevices = true;
        }

        if (this._model.pagingFeed) {
            this._populateValues();
            this._renderStatus(
                this._model._networkDiscoveryPlanFeed.getPristineProperties().status
            );
            this._registerFeedListeners();
            // this._registerPlanFeedListeners();
        }

        this._debouncedButtonEnableDisable();
        this._onFeedRefreshView();
        this._registerGridListeners();
    }

    updateResultLayout() {
        this._populateValues();
        this._renderStatus(this._model._networkDiscoveryPlanFeed.getStatus());
    }

    _gridEntitiesPresent() {
        if (this._deviceEntityGrid) {
            if (
                this._deviceEntityGrid.getTotalEntities() === 0 &&
                !Object.keys(_.get(this._deviceEntityGrid.pagingFeed, "cache", {})).length
            ) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    setRunCancelButtonStatus() {
        const status = this._model._networkDiscoveryPlanFeed.getStatus();
        switch (status) {
            case "DRAFT":
                this.setRunCancelButtonText("Run Now", true);
                if (!this._gridEntitiesPresent()) {
                    this.enableDisableActionButtons(false);
                } else {
                    this.enableDisableActionButtons(true);
                }
                break;
            case "READY":
                this.setRunCancelButtonText("Run Now");
                if (!this._gridEntitiesPresent()) {
                    this.enableDisableActionButtons(false);
                } else {
                    this.enableDisableActionButtons(true);
                }
                break;
            case "RUNNING":
                this.setRunCancelButtonText("Cancel");
                this.enableDisableActionButtons(false);
                break;
            case "CANCELED":
            case "CANCELING":
                this.setRunCancelButtonText("Run Now");
                if (!this._gridEntitiesPresent()) {
                    this.enableDisableActionButtons(false);
                } else {
                    this.enableDisableActionButtons(true);
                }
                this._debouncedSetCount();
                break;
            case "COMPLETE":
                this.setRunCancelButtonText("Run Now");
                if (!this._gridEntitiesPresent()) {
                    this.enableDisableActionButtons(false);
                } else {
                    this.enableDisableActionButtons(true);
                }
                this._debouncedSetCount();
                break;
        }
    }

    setRunCancelButtonText(text, disabled = false) {
        this._model._setViewActionText("runCancelButton", text);

        if (disabled) {
            this._model.gameEditor.disableViewAction("runCancelButton");
        } else {
            this._model.gameEditor.enableViewAction("runCancelButton");
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._deviceEntityGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    _setStatusFromProperties(status) {
        this._setStatusText(status);
        switch (status) {
            case "DRAFT":
                this._setStatus("Draft", "default");
                this._setStatus("Run", "default");
                break;
            case "READY":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "default");
                break;
            case "CANCELED":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "canceled");
                break;
            case "ERROR":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "error");
                break;
            case "CANCELING":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "canceling");
                break;
            case "RUNNING":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "running");
                break;
            case "COMPLETE":
            case "SUCCESS":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "success");
                break;
        }
    }
    _setStatus(state, status) {
        if (this.flowGraphic) {
            this.flowGraphic.setState(state, status);
        }
    }

    _renderStatus(status) {
        this.flowGraphic = undefined;
        this.flowGraphic = new StatusFlow();
        this._flowGraphicContainer.innerHTML = "";
        this._flowGraphicContainer.innerHTML = `<span>Progress: </span>`;
        this._flowGraphicContainer.appendChild(this.flowGraphic.renderer.rootElement);
        this._setStatusFromProperties(status);
    }

    _populateValues() {
        if (
            !_.isUndefined(this._model._networkDiscoveryResultsFeed) &&
            !_.isEmpty(this._model._networkDiscoveryResultsFeed.cache)
        ) {
            this._setDeviceCount();
        }

        if (!_.isUndefined(this._model._networkDiscoveryPlanFeed)) {
            this._setStatusText(this._model._networkDiscoveryPlanFeed.getStatus());
            this.setRunCancelButtonStatus();
        }
        if (this._model.pagingFeed) {
            this._model.pagingFeed.emit("RefreshLinesNumber");
        }
    }

    async _setDeviceCount(reset) {
        if (this._model) {
            if (reset) {
                this._discoveredDeviceCount.innerText = `Discovered Devices: 0`;
            } else {
                let discoveredCount = 0;
                let query = {$and: []};
                if (this._filterQuery.$and) {
                    query.$and = [...this._filterQuery.$and];
                } else {
                    query.$and.push(this._filterQuery);
                }
                query.$and.push({discoveryStatus: {$eq: "DISCOVERED"}});
                discoveredCount =
                    await this._model._networkDiscoveryResultsEntityDef.queryNetworkDiscoveryResultCount(
                        this._model.activeOrgId,
                        query
                    );
                if (!discoveredCount) {
                    discoveredCount = 0;
                }
                let s = discoveredCount === 1 ? "" : "s";
                this._discoveredDeviceCount.innerText = `Discovered Device${s}: ${discoveredCount}`;
                // Set showKnownDevices to enabled if disabled when result count is greater than 0
                const resultCount = _.get(
                    this._model._networkDiscoveryResultsFeed,
                    "totalEntities",
                    0
                );

                if (
                    resultCount > 0 &&
                    this._knownDevicesActionCmpnt.length === 1 &&
                    this._knownDevicesActionCmpnt[0].disabled
                ) {
                    this._model._gameEditor.enableViewAction("showKnownDevices");
                }
            }
        }
    }

    _setStatusText(status) {
        this._discoveryStatus.innerText = `Status: ${status}`;
    }

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderDetailsFromDeviceBtn() {
        const buttonHolderEl = this._formsComponent.renderer._rootElem.querySelector(
            ".rendered_control.text.selected_device_btn"
        );
        if (!buttonHolderEl.contains(this._detailsFromDeviceBtn.renderer.rootElement)) {
            buttonHolderEl.innerHTML = "<label></label>";
            buttonHolderEl.appendChild(this._detailsFromDeviceBtn.renderer.rootElement);
        }
    }

    enableDisableActionButtons(value) {
        if (value) {
            this._model.gameEditor.enableViewAction("showKnownDevices");
            if (
                !_.isEmpty(this._deviceEntityGrid) &&
                !_.isEmpty(this._deviceEntityGrid._selectedRows)
            ) {
                // this._model.gameEditor.enableViewAction("excludeSelection");
                this._model.gameEditor.enableViewAction("importSelection");
            }
            this._model.gameEditor.enableViewAction("download");
        } else {
            this._model.gameEditor.disableViewAction("showKnownDevices");
            this._model.gameEditor.disableViewAction("importSelection");
            // this._model.gameEditor.disableViewAction("excludeSelection");
            this._model.gameEditor.disableViewAction("download");
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onClearResultsClick() {
        this._model.clearResults();
    }

    _onExcludeSelection() {
        this._model.excludeResults();
    }

    _onShowKnownDevices() {
        if (this._showKnownDevices) {
            if (this._onlyCurrentPlan) {
                this._filterQuery = {
                    $and: [
                        {deviceStatus: {$ne: "EXCLUDE"}},
                        {deviceStatus: {$nin: ["KNOWN"]}},
                        {planId: {$eq: this._model._networkDiscoveryPlanFeed.id}},
                    ],
                };
            } else {
                this._filterQuery = {
                    $and: [{deviceStatus: {$ne: "EXCLUDE"}}, {deviceStatus: {$nin: ["KNOWN"]}}],
                };
            }

            this._model.pagingFeed.setQuery(this._filterQuery);
            this._model._setViewActionText("showKnownDevices", "Show Known Devices");
            this._deviceEntityGrid.renderer._emptyMessage.innerHTML = UNKNOWN_DEVICES_EMPTY;
            this._userDataStorage.setData(this._showKnownDevices, "show_known_devices");
            this._showKnownDevices = false;
            this._filterApplied = true;
        } else {
            if (this._onlyCurrentPlan) {
                this._filterQuery = {
                    $and: [
                        {deviceStatus: {$ne: "EXCLUDE"}},
                        {planId: {$eq: this._model._networkDiscoveryPlanFeed.id}},
                    ],
                };
            } else {
                this._filterQuery = {deviceStatus: {$ne: "EXCLUDE"}};
            }

            this._model.pagingFeed.setQuery(this._filterQuery);
            this._model._setViewActionText("showKnownDevices", "Hide Known Devices");
            this._deviceEntityGrid.renderer._emptyMessage.innerHTML = ALL_DEVICES_EMPTY;
            this._userDataStorage.setData(this._showKnownDevices, "show_known_devices");
            this._showKnownDevices = true;
            this._filterApplied = true;
        }

        this._model.pagingFeed._filter = this._filterQuery;
        this._model.pagingFeed._resultsFeedReestablish();
        this._model.pagingFeed.whenFeedReady().then(() => {
            this._deviceEntityGrid.refreshView();
            this._deviceEntityGrid.refreshLinesNumber();
        });
    }
    async _onRunCancelClick() {
        const action = event.target.innerText;

        switch (action) {
            case "Run Now":
                this._setDeviceCount();
                this._model._planRunning = true;
                // this._model._networkDiscoveryPlanFeed.setStatus("RUNNING");
                // this._setStatusFromProperties("RUNNING");
                this.setRunCancelButtonText("Starting...", true);
                await this._runNetworkDiscoveryPlan();
                this._model.gameEditor.enableViewAction("runCancelButton");

                break;
            case "Cancel":
                this._cancelNetworkDiscoveryPlan();
                break;
        }
    }

    async _runNetworkDiscoveryPlan() {
        return this._model.runNetworkDiscoveryWork();
    }

    _cancelNetworkDiscoveryPlan() {
        this._model.cancelNetworkDiscoveryWork();
    }

    _onImportSelectionClick() {
        this._model.importAction();
    }

    _onDownloadClick() {
        this._model.gameEditor.disableViewAction("download");
        this._model
            .downloadGridAsCSV(this._deviceEntityGrid.getColumnOrder(), this._showKnownDevices)
            .finally(() => {
                this._model.gameEditor.enableViewAction("download");
            });
    }

    _onResultsFeedUpdated() {
        if (this._model) {
            this._setDeviceCount();
            this._updateGridCount();
            // this.hideShowGridMessage();
        }
    }

    _onGridColumnUpdated() {
        this._model.gameEditor.onGridColumnUpdated();
    }

    _onGridBusyStart() {
        if (this._model.pagingFeed.totalEntities > this._model.pagingFeed.pageSize * 2) {
            let gridBusyEnded = false;
            this._deviceEntityGrid.once("GridBusyEnd", () => {
                gridBusyEnded = true;
            });
            this._model._modalUserFeedback.displayLoading().then(() => {
                if (gridBusyEnded) {
                    this._model._modalUserFeedback.hideDisplayed();
                } else {
                    this._deviceEntityGrid.once("GridBusyEnd", () => {
                        this._model._modalUserFeedback.hideDisplayed();
                    });
                }
            });
        }
    }

    _onUserDblClickedRow(obj) {
        this.selectedRow = _.get(
            this._model._networkDiscoveryResultsFeed,
            "cache." + obj.selectedRow,
            false
        );
        if (this.selectedRow) {
            this._switchView(Registrations.NETWORK_DISCOVERY_EDITOR_SUBVIEW_RESULTS_LOGS);
        }
    }

    _onPlanPropertiesChanged(properties) {
        if (properties.status === "RUNNING") {
            this._feedRefreshed = false;
            this._model._runningStart = true;
            // this._model._gameEditor.retrieveNetworkDiscoveryExecutionEntity(true);

            if (this._noDiscovery === true) {
                this.render();
            }
        } else if (properties.status === "COMPLETE" || properties.status === "ERROR") {
            this._feedRefreshed = true;
            this._model._runningStart = false;
        } else if (properties.status === "CANCELED") {
            this._feedRefreshed = true;
            this._model._runningStart = true;
            // this._onExecutionFeedUpdated();
        }
        this._model._networkDiscoveryPlanFeed.setStatus(properties.status);
        this._setStatusFromProperties(properties.status);
        // this._setDeviceCount();
        this._debouncedButtonEnableDisable();
    }

    _onExecutionFeedUpdated() {
        try {
            if (_.isEmpty(this._deviceEntityGrid)) {
                _.defer(this._onExecutionFeedUpdated);
            }
            if (!_.isEmpty(this._model) && this._feedRefreshed === false) {
                this._feedRefreshed = true;
                if (
                    this._model._runningStart === true ||
                    this._model.pagingFeed.totalEntities === 0
                ) {
                    // Do this once
                    this._model._networkDiscoveryExecutionEntity
                        .stopRelatedResultsFeed()
                        .then(() => {
                            if (this._deviceEntityGrid) {
                                this._deviceEntityGrid._unregisterListeners();
                            }
                            return this._model._getResultsFeed(this._filterQuery);
                        })
                        .then(() => {
                            // Assign new _pagingFeed to grid since the old one is killed and a new one is created.
                            // The grid does not automatically take it
                            this._deviceEntityGrid._pagingFeed = this._model.pagingFeed;
                            this._deviceEntityGrid._registerListeners();
                            this._deviceEntityGrid.refreshView();
                            this._deviceEntityGrid.refreshLinesNumber();
                            if (!_.isEmpty(_.get(this._model.pagingFeed, "cache", []))) {
                                this._hideDefaultMessageDisplay();
                            }
                            this.updateResultLayout();
                            return Promise.resolve();
                        })
                        .then(() => {
                            if (this._model._runningStart === true) {
                                this._model._runningStart = false;
                                return this._model._gameEditor.getWorkFeed();
                            }
                        })
                        .catch((error) => {
                            if (this._logger) {
                                this._logger.warn(
                                    {error},
                                    "NetworkDiscovery::Results::ExecutionFeedUpdated Error"
                                );
                            } else {
                                console.log(error);
                            }
                        });
                }
            }
        } catch (error) {
            if (this._logger) {
                this._logger.warn({error}, "NetworkDiscovery::Results::ExecutionFeedUpdated Error");
            } else {
                console.log(error);
            }
        }
    }

    _onFeedRefreshView() {
        // if (this._model._networkDiscoveryPlanFeed.getStatus() === "RUNNING") {
        this.updateResultLayout();
        // this._onExecutionFeedUpdated();
        // }
        // this.hideShowGridMessage();
    }

    hideShowGridMessage() {
        if (!this._filterApplied && !_.isEmpty(this._model)) {
            let totalEntities = _.get(this._model.pagingFeed, "cache")
                ? Object.keys(_.get(this._model.pagingFeed, "cache")).length
                : _.isUndefined(this._model.pagingFeed)
                ? 0
                : this._model.pagingFeed.totalEntities;

            if (totalEntities === 0) {
                this._showDefaultMessageDisplay();
                this.enableDisableActionButtons(false);
            } else {
                this._hideDefaultMessageDisplay();
                this.enableDisableActionButtons(true);
            }
        }
    }

    _onUserSorted(eventData) {
        this._model._onUserSorted(eventData);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        const isCurrentPlan = this._planSelection.getValue();
        this._model.updateSelectedRows(selectedRowIds, isCurrentPlan);
    }

    _onResultFeedInitialized() {
        this._deviceEntityGrid.refreshView();
        this._deviceEntityGrid.refreshLinesNumber();
    }

    _onImportComplete() {
        this._deviceEntityGrid.setSelectedRows();
    }

    _onPlanSelectionChange(val) {
        // Set filter on grid
        this._userDataStorage.setData(val, "is_current_plan");
        if (val) {
            this._onlyCurrentPlan = true;
            this._model._gameEditor.enableViewAction("clearResults");
            if (
                this._model._networkDiscoveryPlanFeed.status !== "RUNNING" &&
                this._model._networkDiscoveryPlanFeed.status !== "CANCELING"
            ) {
                this._model.gameEditor.enableViewAction("excludeSelection");
            }

            if (!this._showKnownDevices) {
                this._filterQuery = {
                    $and: [
                        {deviceStatus: {$ne: "EXCLUDE"}},
                        {deviceStatus: {$nin: ["KNOWN"]}},
                        {planId: {$eq: this._model._networkDiscoveryPlanFeed.id}},
                    ],
                };
            } else {
                this._filterQuery = {
                    $and: [
                        {deviceStatus: {$ne: "EXCLUDE"}},
                        {planId: {$eq: this._model._networkDiscoveryPlanFeed.id}},
                    ],
                };
            }

            this._model.pagingFeed.setQuery(this._filterQuery);
        } else {
            this._onlyCurrentPlan = false;
            this._model._gameEditor.disableViewAction("clearResults");
            this._model.gameEditor.disableViewAction("excludeSelection");
            if (!this._showKnownDevices) {
                this._filterQuery = {
                    $and: [{deviceStatus: {$ne: "EXCLUDE"}}, {deviceStatus: {$nin: ["KNOWN"]}}],
                };
            } else {
                this._filterQuery = {deviceStatus: {$ne: "EXCLUDE"}};
            }
            this._model.pagingFeed.setQuery(this._filterQuery);
        }

        this._model.pagingFeed._filter = this._filterQuery;
        this._model.pagingFeed._resultsFeedReestablish();
        this._model.pagingFeed.whenFeedReady().then(() => {
            this._deviceEntityGrid.refreshView();
            this._deviceEntityGrid.refreshLinesNumber();
        });
    }

    _resetSelectedRows() {
        this._deviceEntityGrid.setSelectedRows([]);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _toLocaleString(val) {
        let d = new Date(val);
        if (Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.getTime())) {
            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        } else {
            return "";
        }
    }

    _showDefaultMessageDisplay() {
        // let message;
        // message = {
        //     message: "No Network Discovery results available",
        // };
        // if (this._model._networkDiscoveryPlanFeed.getStatus() === "RUNNING") {
        //     message = {
        //         message: "Network Discovery is running...",
        //     };
        // }
        // return this._model.gameEditor
        //     .showDefaultMessageView(message)
        //     .then(() => {
        //         this._defaultViewActive = true;
        //     })
        //     .catch((err) => {
        //         this._logger.warn(
        //             {error: err},
        //             "DeviceListViewerRenderer._showDefaultMessageDisplay error"
        //         );
        //     });
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor
            .hideDefaultMessageView()
            .then(() => {
                this._defaultViewActive = false;
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "DeviceListViewerRenderer._hideDefaultMessageDisplay error"
                );
            });
    }

    /** navigate inside view tab */
    _switchView(switchTo, params) {
        this._model._gameEditor.setActiveView(
            switchTo,
            [
                {
                    value: {
                        fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_RESULTS,
                        viewState: {
                            networkDiscoveryResultEntity: this.selectedRow,
                        },
                    },
                    content: "Details",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            params
                ? params
                : {
                      networkDiscoveryResultEntity: this.selectedRow,
                      networkDiscoveryResultFeed: this._model._networkDiscoveryResultsFeed,
                  }
        );
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = NetworkDiscoveryResultsViewRenderer;
